import type { Direction } from "../../../engine/direction";
import { BurstParticle } from "./burstParticle";

export class LeafDebrisParticle extends BurstParticle {
	constructor(originX: number, originY: number, direction?: Direction) {
		super(
			originX,
			originY,
			{
				ttl: [400, 1200],
				size: [0.35, 0.2],
				color: { r: 50, g: 120, b: 40 },
				speed: [1.0, 1.5],
				gravity: 0.9,
			},
			direction,
		);
	}
}
